import React from "react";
import { ToastContainer } from "react-toastify";

import useAuthentication, { IAuthHook } from "./useAuthentication";

interface MonteflorContextProps extends IAuthHook {}

const MyContext = React.createContext<MonteflorContextProps | null>(null);

const MonteflorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authentication = useAuthentication();

  React.useEffect(() => {
    void authentication.getAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- solo al montar
  }, []);

  return (
    <MyContext.Provider value={authentication}>
      <ToastContainer theme={'colored'} closeOnClick={false} position={'top-center'} autoClose={3000} hideProgressBar />

      {children}
    </MyContext.Provider>
  );
};

const useMonteflor = () => {
  const context = React.useContext(MyContext);

  if (context == null) {
    throw new Error('useMonteflor must be used within a MonteflorProvider');
  }

  return context;
};

export { MonteflorProvider, useMonteflor };
export default MonteflorProvider;
